import app from "flarum/forum/app";
import {extend, override} from "flarum/common/extend";
import LogInModal from "flarum/forum/components/LogInModal";
import LogInButton from "flarum/forum/components/LogInButton";
import ChangeEmailModal from "flarum/forum/components/ChangeEmailModal";
import Button from "flarum/common/components/Button";
import SignUpModal from "flarum/forum/components/SignUpModal";
import LogInButtons from "flarum/forum/components/LogInButtons";
import {authQQ} from "../QQAuth";

export default function() {
  override(LogInModal.prototype, "body", function() {
    return [<LogInButtons/>];
  });
  extend(LogInButtons.prototype, "items", function(items) {
    items.add("steamLogin", LogInButton.component({
      className: "Button LogInButton--steam",
      icon: "fab fa-steam",
      path: "/auth/steam"
    }, app.translator.trans("rhodes-island.forum.log_in.steam")));
    items.add("qqLogin", <Button icon="fab fa-qq" className={"Button LogInButton LogInButton--qq"} onclick={authQQ}>
      {app.translator.trans("rhodes-island.forum.log_in.qq")}
    </Button>);
  })
  override(LogInModal.prototype, "footer", function() {
    return <>
      <p>{app.translator.trans("rhodes-island.forum.log_in.steam_tip")}</p>
      <p>{app.translator.trans("rhodes-island.forum.log_in.qq_tip")}</p>
    </>;
  });
  extend(SignUpModal.prototype, "fields", function (items) {
    items.remove("username");
  });
  override(SignUpModal.prototype, "footer", function() {
    return [];
  });
  extend(ChangeEmailModal.prototype, "fields", function(items) {
    items.remove("password");
  });
}
